import GetOrganisationByIdRequestModelBase from '../_generated/modelBases/get-organisation-by-id-request-model-base';

export default class GetOrganisationByIdRequestModel extends GetOrganisationByIdRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
